import { useOrganizationsStore } from '@/stores/organizations';
import { useUsersStore } from '@/stores/users';

/**
 * Resolves which organizations the current user can see and manage: every
 * organization for a super admin, or only the ones where they hold the
 * ORG_ADMIN organization role otherwise.
 * @returns The visible organizations, whether the user is a super admin, and
 * whether they have any organization-level access at all.
 */
export const useVisibleOrganizations = () => {
  const organizations = useOrganizationsStore((state) => state.organizations);
  const { isSuperAdmin, orgAdminOrganizationIds } = useUsersStore((state) => ({
    isSuperAdmin: state.checkIsSuperAdmin(),
    orgAdminOrganizationIds: state.getOrgAdminOrganizationIds(),
  }));

  const visibleOrganizations = isSuperAdmin
    ? organizations
    : organizations.filter((organization) =>
        orgAdminOrganizationIds.includes(organization.id),
      );

  return {
    visibleOrganizations,
    isSuperAdmin,
    hasOrganizationsAccess: isSuperAdmin || visibleOrganizations.length > 0,
  };
};
